import { useState, useEffect } from 'react';
import { getCurrentSubdomain, isSubdomainEnvironment } from '../utils/subdomainUtils';
import subdomainService from '../services/subdomainService';

export interface UseSubdomainReturn {
  subdomain: string;
  isSubdomainEnv: boolean;
  company: any | null;
  loading: boolean;
  error: string | null;
}

export const useSubdomain = (): UseSubdomainReturn => {
  const [subdomain, setSubdomain] = useState<string>('');
  const [isSubdomainEnv, setIsSubdomainEnv] = useState<boolean>(false);
  const [company, setCompany] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const initializeSubdomain = async () => {
      try {
        setLoading(true);
        setError(null);

        const isSubdomain = isSubdomainEnvironment();
        console.log("isSubdomain:::::::", isSubdomain);
        setIsSubdomainEnv(isSubdomain);

        if (isSubdomain) {
          const currentSubdomain = getCurrentSubdomain();
          console.log("currentSubdomain:::::::", currentSubdomain);
          setSubdomain(currentSubdomain);

          if (currentSubdomain) {
            try {
              const companyData = await subdomainService.getCompanyBySubdomain(currentSubdomain);
              setCompany(companyData);
            } catch (err) {
              setError('Company not found for this subdomain');
              setCompany(null);
            }
          }
        }
      } catch (err) {
        setError('Failed to initialize subdomain');
      } finally {
        setLoading(false);
      }
    };

    initializeSubdomain();
  }, []);

  return {
    subdomain,
    isSubdomainEnv,
    company,
    loading,
    error
  };
}; 